(() => {
  const root = document.querySelector('[data-newsletter-popup]');
  if (!root) return;

  const storagePrefix = 'mk-newsletter-popup-v3';
  const minimizedKey = storagePrefix + '-minimized';
  const pendingKey = storagePrefix + '-pending';
  const pendingAtKey = storagePrefix + '-pending-at';
  const email = root.querySelector('#mk-newsletter-popup-email');
  const form = root.querySelector('form');

  function isChallengePage() {
    const path = window.location.pathname.toLowerCase();
    const title = document.title.toLowerCase();
    return path.includes('/challenge') || path.includes('/checkpoint') || title.includes('captcha') || title.includes('challenge');
  }

  if (isChallengePage()) {
    root.remove();
    return;
  }

  function show() {
    root.classList.remove('mk-newsletter-popup--success');
    root.setAttribute('aria-hidden', 'false');
    sessionStorage.removeItem(minimizedKey);
    window.setTimeout(() => email?.focus({ preventScroll: true }), 120);
  }

  function minimize() {
    root.setAttribute('aria-hidden', 'true');
    sessionStorage.setItem(minimizedKey, 'true');
  }

  function showSuccess() {
    root.classList.add('mk-newsletter-popup--success');
    root.setAttribute('aria-hidden', 'false');
    sessionStorage.removeItem(minimizedKey);
    sessionStorage.removeItem(pendingKey);
    sessionStorage.removeItem(pendingAtKey);
  }

  function hasRecentPendingSignup() {
    const pendingAt = Number(sessionStorage.getItem(pendingAtKey) || 0);
    return sessionStorage.getItem(pendingKey) === 'true' && Date.now() - pendingAt < 10 * 60 * 1000;
  }

  const params = new URLSearchParams(window.location.search);
  if (params.get('newsletter_signup') === 'success') {
    showSuccess();
    window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
  } else if (hasRecentPendingSignup()) {
    minimize();
  } else if (sessionStorage.getItem(minimizedKey) !== 'true') {
    window.setTimeout(show, 1200);
  }

  root.querySelectorAll('[data-newsletter-popup-open]').forEach((button) => {
    button.addEventListener('click', show);
  });

  root.querySelectorAll('[data-newsletter-popup-minimize]').forEach((button) => {
    button.addEventListener('click', minimize);
  });

  form?.addEventListener('submit', () => {
    sessionStorage.setItem(pendingKey, 'true');
    sessionStorage.setItem(pendingAtKey, String(Date.now()));
    minimize();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') minimize();
  });
})();
